export class ScheduledPremierServiceDTO{
    public premierServiceScheduleId!: number;
    public added!: string;
    public customerPremierPartnerServiceConfigurationId!: number;
    public moovStepPremierServiceConfigurationId!: number;
    public customerId!: number;
    public clientId!: number;
    public executeOnOrAfter!: string;
    public startedAt!: string;
    public recurring!: boolean;
    public inProgress!: boolean;
    public addedByUserId!: number;
    public recurrenceType!: number;
    public recurrenceInterval!: number;
    public recurrenceDays!: string;
    public recurrenceHour!: number;
    public recurrenceMinute!: number;
    public moovDefinitionId!: number;
    public moovConfigurationId!: number;
    public moovConfigurationFilenameStartsWith!: string;
    public moovConfigurationFilenameContains!: string;
    public premierServiceProductType!: string;
    public premierPartnerId!: number;
}